import { GroupType, IntegrationType } from '@kcftech/prometheus-client';

export enum AuthenticationType {
    OAuth = 'oauth',
    Basic = 'basic',
    ApiKey = 'apikey',
}

export const AuthenticationTypeOptions = [
    {
        title: 'OAuth',
        value: AuthenticationType.OAuth,
    },
    {
        title: 'Basic',
        value: AuthenticationType.Basic,
    },
    {
        title: 'API Key',
        value: AuthenticationType.ApiKey,
    },
];

export enum IntegrationState {
    Active = 'ACTIVE',
    Inactive = 'INACTIVE',
}

export const SoftwareNameOptions = {
    [IntegrationType.Cmms]: [
        'Maximo',
        'SAP EAM',
        'Oracle EAM',
        'Hexagon EAM',
        'MaintainX',
        'eMaint',
        'SAP S/4HANA',
        'LLumin',
        'MaintenanceConnection',
        'Fiix',
        'Custom API',
    ],
    // TODO: Handle this type
    [IntegrationType.IssuePublisher]: [],
};

export type IntegrationDetails = Readonly<{
    base_url?: string;
    create_sr_uri?: string;
    query_sr_uri?: string;
    systemid: string;
    id?: string;
    secret?: string;
    authtype?: AuthenticationType;
    tokenurl?: string;
}>;

export type IntegrationDetailsResponse = Readonly<{
    INACTIVE?: IntegrationDetails[];
    ACTIVE?: IntegrationDetails[];
}>;

export type IntegratedItemType = GroupType.Assembly | GroupType.Asset;

export type IntegrationMappingDetails = Readonly<{
    sd_id: string;
    sd_path?: string;
    sd_type: IntegratedItemType;
    sd_name?: string;
    cmms_asset_id?: string;
    cmms_description?: string;
    cmms_location?: string;
    cmms_site?: string;
}>;
